import { Arrow, Content, Portal } from "@radix-ui/react-tooltip";
import { Tooltip, Trigger } from "@radix-ui/react-tooltip";
import { contentStyles } from "./tooltipV3.styles";
import type { PropsWithChildren, ReactNode } from "react";
import type {
  TooltipContentProps,
  TooltipPortalProps,
  TooltipProps,
} from "@radix-ui/react-tooltip";

type Props = {
  triggerAsChild?: boolean;
  showArrow?: boolean;
  content: ReactNode;
  enabled?: boolean;
  usePortal?: boolean;
  contentProps?: Omit<TooltipContentProps, "children">;
  portalProps?: TooltipPortalProps;
} & TooltipProps &
  PropsWithChildren;

export function TooltipV3(props: Props) {
  const {
    children,
    triggerAsChild = true,
    showArrow = true,
    enabled = true,
    content,
    usePortal = true,
    contentProps = {},
    portalProps = {},
    ...root
  } = props;

  if (!enabled) {
    return children;
  }

  const renderContent = (
    <Content {...contentProps} css={contentStyles}>
      {content}
      {showArrow && <Arrow css={{ fill: "white" }} />}
    </Content>
  );

  return (
    <Tooltip {...root}>
      <Trigger asChild={triggerAsChild}>{children}</Trigger>

      {usePortal ? (
        <Portal {...portalProps}>{renderContent}</Portal>
      ) : (
        renderContent
      )}
    </Tooltip>
  );
}
